import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AuthContext from './Context';
import { UserContext } from '../UserProvider';

export const AuthProvider = ({
  children,
}) => {
  const userContextValue = useContext(UserContext);

  return (
    <AuthContext.Provider
      value={userContextValue}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const AuthConsumer = AuthContext.Consumer;
